import React from 'react';
import { Link, ButtonV2 } from '@zola/zola-ui';
import OtherRegistriesRow from './OtherRegistriesRow';

import './OtherRegistries.less';

const OtherRegistries = ({ otherRegistriesDetails }) => {
  const rows = otherRegistriesDetails.map(otherRegistry => (
    <OtherRegistriesRow
      storeName={otherRegistry.store_name}
      registryUrl={otherRegistry.url}
      syncStatus={otherRegistry.status}
      lastSyncedDate={otherRegistry.last_run_at}
      enableEditAndDelete={
        otherRegistry.status === 'COMPLETED' || otherRegistry.status === 'FAILED'
      }
      registryId={otherRegistry.id}
      key={otherRegistry.id}
      retailerDomain={otherRegistry.domain}
    />
  ));

  const handleAddRegistryOnClick = () => {
    window.location.href = '/wedding-registry/add-other-registry';
  };

  return (
    <div>
      <div className="other-registries__grid__container">
        <p className="other-registries__grid__subtext">
          We sync registries you’ve added daily to update your Zola registry with the latest info
          for all gifts from your other registries. Visit&nbsp;
          <Link
            inline
            className="other-registries__grid__subtext__link"
            href="https://help.zola.com/hc/en-us/sections/115000736191-Adding-Gifts-and-Registries-From-Other-Stores"
          >
            this page
          </Link>
          &nbsp;for more.
        </p>
        <div className="other-registries__grid__header-row hidden-xs">
          <div className="other-registries__grid__header-row_store">Store</div>
          <div className="other-registries__grid__header-row_url">Registry URL</div>
          <div className="other-registries__grid__header-row_status">Status</div>
        </div>
        {rows}
      </div>
      <div className="other-registries__populated-state__button">
        <ButtonV2 onClick={handleAddRegistryOnClick}>Add Another Registry</ButtonV2>
      </div>
    </div>
  );
};

export default OtherRegistries;



// WEBPACK FOOTER //
// ./src/components/settings/registry/OtherRegistries/OtherRegistries.jsx